import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './AboutHorses.module.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
const DailyRaceBlocks = ({ elem }) => {
    const numbers = elem.split('/').map(Number);
    return (_jsxs("div", { children: [_jsx("p", { children: elem }), _jsx("div", Object.assign({ className: styles.blocks }, { children: Array.from(Array(numbers[1]).keys()).map((blockId) => {
                    const isFilled = blockId < numbers[0];
                    return _jsx("div", { className: isFilled ? styles.blocks__active : '' }, blockId);
                }) }))] }));
};
const AboutHorses = ({ elem, className, borderRight }) => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: cn(styles.element, className) }, { children: Object.keys(elem)
            .filter((key) => !['condition', 'id', 'name'].includes(key))
            .map((key) => (_jsxs("div", Object.assign({ className: cn(styles.list, 'd-flex flex-column', borderRight && styles['isBorderRight']) }, { children: [_jsx("div", { children: t(key) }), _jsx("div", Object.assign({ className: styles.desc }, { children: key === t('daily_race') ? (_jsx(DailyRaceBlocks, { elem: elem[key] })) : (elem[key]) }))] }), key))) })));
};
export default AboutHorses;
